import { Map } from 'immutable';
import { has } from 'lodash';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function searchInspectionReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SEARCH_REQUEST_START:
      return state.set('loading', true).set('data', null).set('error', null);
    case actionTypes.SEARCH_REQUEST_SUCCESS:
      return state.set('loading', false).set('data', mapInspections(action.payload));
    case actionTypes.SEARCH_REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    case actionTypes.ADD_REQUEST_START:
      return state
        .setIn(['data', action.payload.taxCode], mapItemLoading(state, action.payload, true))
        .set('error', null);
    case actionTypes.ADD_REQUEST_SUCCESS:
      return state.setIn(
        ['data', action.payload.taxCode],
        mapItemLoading(state, action.payload, false),
      );
    case actionTypes.ADD_REQUEST_FAILURE:
      return state
        .setIn(['data', action.payload.taxCode], mapItemLoading(state, action.payload, false))
        .set('error', action.payload);
    case actionTypes.DELETE_REQUEST_START:
      return state
        .setIn(['data', action.payload.taxCode], mapItemLoading(state, action.payload, true))
        .set('error', null);
    case actionTypes.DELETE_REQUEST_SUCCESS:
      return state.setIn(
        ['data', action.payload.taxCode],
        mapItemLoading(state, action.payload, false),
      );
    case actionTypes.DELETE_REQUEST_FAILURE:
      return state
        .setIn(['data', action.payload.taxCode], mapItemLoading(state, action.payload, false))
        .set('error', action.payload);
    case actionTypes.SEARCH_RESET:
      return state.set('loading', false).set('data', null).set('error', null);
    default:
      return state;
  }
}

function mapInspections(inspections) {
  let inspectionsMap = {};

  inspections.forEach((inspection) => {
    inspectionsMap[inspection.taxCode] = inspection;
  });
  return Map(inspectionsMap);
}

function mapItemLoading(state, payload, loading) {
  const inspection = state.getIn(['data', payload.taxCode]);
  return Object.assign({}, inspection, {
    loading: loading,
    added: has(payload, 'added') ? payload.added : inspection.added,
  });
}
